const checkoutBreakdownList = $('#checkout__breakdown');
let needOrders, weekOrders;
needOrders = 0;
weekOrders = 0;


const checkoutEvents = new EventDelegator([
    {
        selector: '#js-app',
        eventType: 'click',
        events:
            {
                addtocheckout: (e, d) =>
                {
                    addToCheckout(d.addtocheckout, e.target);
                },
                removefromcheckout: (e, d) =>
                {
                    removeFromCheckout(d.removefromcheckout, e.target);
                },
                orderall: (e, d) =>
                {
                    orderAll(d.orderall, e.target);
                }
            }
    }]);


const menu = {
    //misc
    skipAllTandC: {
        id: 'skipAllTandC',
        price: 7,
        desc: 'Skip T&Cs',
        section: 'miscellaneous',
        addCallBack: () =>
        {
            display_tc(false);
        }
    },

    //sahara/mix
    cleanMeatCo: {
        id: 'cleanMeatCo',
        price: 40,
        desc: 'Clean Meat Co',
        section: 'sahara',
    },
    vrSuit: {
        id: 'vrSuit',
        price: 'js-eprice-3',
        desc: 'Optic Breach VR Suit',
        section: 'sahara',
        addCallBack: () =>
        {
            disableOrderAll('need');
        }
    },
    memoryBoost: {
        id: 'memoryBoost',
        price: 'js-eprice-1',
        desc: 'Memory Boost',
        section: 'sahara',
        addCallBack: () =>
        {
            disableOrderAll('need');
        }
    },
    infinityZ: {
        id: 'infinityZ',
        price: 'js-eprice-5',
        desc: 'InfinityZ Space Travel',
        section: 'sahara',
        addCallBack: () =>
        {
            disableOrderAll('week');
        }
    },
    nanoDoc: {
        id: 'nanoDoc',
        price: 'js-eprice-7',
        desc: 'Dose Of NanoDoc',
        section: 'sahara',
        addCallBack: () =>
        {
            disableOrderAll('week');
        }
    },
    ampereModel7: {
        id: 'AmpereModel7',
        price: 36000,
        desc: 'Ampere Model 7',
        section: 'sahara'
    },
    droneDelivery: {
        id: 'droneDelivery',
        price: 10,
        desc: 'Sahara Supreme',
        section: 'sahara'
    },
    milk: {
        id: 'milk',
        price: 3,
        desc: 'Milk',
        section: 'sahara'
    },

    //news
    shareLocation: {
        id: 'shareLocation',
        price: 2,
        desc: 'Block Location Sharing',
        section: 'xyz_news'
    },
    newsNotifications: {
        id: 'newsNotification',
        price: 2,
        desc: 'Disable Notifications',
        section: 'xyz_news'
    },
    shareFacialReactions: {
        id: 'shareFacialReactions',
        price: 2,
        desc: 'Disable Sharing Facial Reactions',
        section: 'xyz_news'
    },
    subscription: {
        id: 'subscription',
        price: 2,
        desc: 'Unsubscribe From Emails',
        section: 'xyz_news'
    },
    noAIStories: {
        id: 'noAIStories',
        price: 2,
        desc: 'Remove AI Stories',
        section: 'xyz_news',
        keepEnabled: true,
        addCallBack: () =>
        {
            aiStoriesControl(true, false);
        },
        rmvCallBack: () =>
        {
            aiStoriesControl(false, false);
        }
    },
    fakeNewsProtection: {
        id: 'fakeNewsProtection',
        price: 2,
        desc: 'Fake News Protection',
        section: 'xyz_news',
        addCallBack: () =>
        {
            popupContinue();
        }
    },


    //social
    mentions: {
        id: 'mentions',
        price: 2,
        desc: 'See Name Mentions',
        section: 'chirpr',
        addCallBack: () =>
        {
            revealMentions();
        }
    },
    disableAutomatedPost: {
        id: 'disableAutomatedPost',
        price: 2,
        desc: 'Disable Automated Posts',
        section: 'chirpr',
        addCallBack: () =>
        {
            postAutomatedPost(true);
        }
    },
    friendTracker: {
        id: 'friendTracker',
        price: 2,
        desc: 'Friend Tracker',
        section: 'chirpr',
        addCallBack: () =>
        {
            trackFriends();
        }
    }
};

let cart, checkoutTotal;
cart = {
    miscellaneous: [],
    xyz_news: [],
    chirpr: [],
    sahara: []
};
checkoutTotal = 0;

function disableOrderAll(target)
{
    needOrders += (target === 'need') ? 1 : 0;
    weekOrders += (target === 'week') ? 1 : 0;

    (needOrders >= 2) ? $("#what-you-need [data-orderall]").addClass('btn--disabled').html('All Ordered') : false;
    (weekOrders >= 2) ? $("#best-deals [data-orderall]").addClass('btn--disabled').html('All Ordered') : false;
}


function orderAll(orders, self)
{
    orders = orders.split(' ');
    $(self).addClass('btn--disabled').html('All Ordered');

    for (const o of orders)
    {
        const target = $('[data-addtocheckout="' + o + '"]');
        addToCheckout(o, target);
    }
}

function addToCheckout(item, target)
{
    console.log(" item = ", item);
    console.log(" target = ", target);
    const section = menu[item]['section'];
    cart[section] = cart[section].includes(menu[item]) ? cart[section] : [...cart[section], menu[item]];
    buildCheckoutList();

    !menu[item]['keepEnabled'] ? $('[data-addtocheckout="' + item + '"]').addClass('btn--disabled').html('Added') : false;

    const callback = menu[item]['addCallBack'] ? menu[item]['addCallBack'] : false;
    if (target)
    {
        kaching(target, menu[item]['price'], callback);
    }
    else
    {
        callback ? callback() : false;
    }
}

function kaching(target, price, callback, refund)
{
    if ($(target).attr('data-preventkaching') === 'true')
    {
        callback ? callback() : false;
    }
    else
    {
        price = getPrice(price);
        const classes = refund ? 'ka-ching refund' : 'ka-ching';
        $(target).attr('data-kaching', '$' + price + '.00').addClass(classes);
        refund ? play_sound(1) : play_sound(3);
        setTimeout(function ()
        {
            $(target).removeClass(classes);
            callback ? callback() : false;
        }, 1010);
    }
}

function removeFromCheckout(item, target)
{
    const section = menu[item]['section'];
    cart[section] = cart[section].filter(i => i.id !== menu[item]['id']);
    buildCheckoutList();

    const callback = menu[item]['rmvCallBack'] ? menu[item]['rmvCallBack'] : false;
    if (target)
    {
        kaching(target, menu[item]['price'], callback, true);
    }
    else
    {
        callback ? callback() : false;
    }
}

function buildCheckoutList()
{
    checkoutBreakdownList.html('');

    let noItems, newCheckoutTotal;
    noItems = true;
    newCheckoutTotal = 0;

    for (const section in cart)
    {
        if (cart[section].length > 0)
        {
            noItems = false;
            const title = new Element({element: 'P', classes: 'breakdown__title', content: section.replace("_", " ").toUpperCase()});
            const list = new Element({classes: 'breakdown__list'});
            for (const item of cart[section])
            {
                const cost = getPrice(item.price);
                newCheckoutTotal += cost;
                const listItem = new Element({classes: 'breakdown__list-item'});
                const label = new Element({element: 'SPAN', content: item.desc});
                const price = new Element({element: 'B', content: cost.toString()});
                listItem.append(label).append(price);
                list.append(listItem)
            }
            checkoutBreakdownList.append(title.returnElement()).append(list.returnElement());
        }
    }

    if (noItems)
    {
        const noItemsLabel = new Element({
            element: 'P',
            content: `There's nothing in your cart yet.`,
            classes: 'breakdown__title'
        });
        checkoutBreakdownList.append(noItemsLabel.returnElement());
    }

    let topBarCountUp = new CountUp('top-bar__checkout-total', newCheckoutTotal, {startVal: checkoutTotal});
    let checkoutCountUp = new CountUp('checkout__checkout-total', newCheckoutTotal, {startVal: checkoutTotal});
    topBarCountUp.start();
    checkoutCountUp.start();
    $('#share__checkout-total').html(newCheckoutTotal);

    if (newCheckoutTotal !== checkoutTotal)
    {
        $('#top-bar__balance-btn').addClass('flash');
        setTimeout(function ()
        {
            $('#top-bar__balance-btn').removeClass('flash');
        }, 1100);
    }

    checkoutTotal = newCheckoutTotal;
}

function getPrice(price)
{
    price = (typeof price === 'string') ? $('#' + price).attr('data-eprice') : price;
    return (typeof price === 'string') ? Number(price) : price;
}

function displayCheckout(show)
{
    const checkout = $('#checkout');
    show ? checkout.addClass('active') : checkout.removeClass('active');
    show ? showshare(false, false) : false;
}

